function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M-2.463-1.87h24v24h-24z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentcolor",
  d: "M1.198 11.711c0 .895.729 1.622 1.622 1.622h8.889c.895 0 1.622-.728 1.622-1.622V2.823c0-.895-.728-1.623-1.622-1.623H2.82c-.894 0-1.622.729-1.622 1.623v8.888zm4.667 4.667c0 .894.729 1.623 1.622 1.623h8.889c.895 0 1.622-.73 1.622-1.623v-8.89c0-.895-.728-1.622-1.622-1.622h-1.844v5.845a2.824 2.824 0 0 1-2.822 2.821H5.865v1.846zM2.82 0h8.889a2.825 2.825 0 0 1 2.822 2.822v1.845h1.845a2.825 2.825 0 0 1 2.822 2.821v8.89a2.824 2.824 0 0 1-2.822 2.821H7.487a2.824 2.824 0 0 1-2.821-2.821v-1.846H2.821A2.824 2.824 0 0 1 0 11.711V2.823A2.823 2.823 0 0 1 2.82 0z"
}));

const SvgIcCopy = (_ref) => {
  let {
    svgRef,
    title
  } = _ref,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIcCopy, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/ic-copy.04395b2b.svg";
export { ForwardRef as ReactComponent };